export function getFreeCardAvailability(availableAt, now = Date.now()) {
  if (typeof availableAt !== "number" || !Number.isFinite(availableAt) || availableAt < 0) {
    return { known: false, waiting: false, label: "Таймер недоступен" };
  }
  const seconds = Math.max(0, Math.ceil(availableAt - now / 1000));
  const time = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
    .map(value => String(value).padStart(2, "0")).join(":");
  return {
    known: true,
    waiting: seconds > 0,
    label: seconds > 0 ? `Бесплатно через ${time}` : "Получить бесплатно",
  };
}

export function getFreeSpinStock(profile, now = Date.now()) {
  const { freeSpins, freeSpinsCapacity: capacity, freeSpinNextAt, freeSpinInterval } = profile;
  if (!Number.isInteger(freeSpins) || !Number.isInteger(capacity) || capacity <= 0) return null;
  const gained = freeSpinNextAt > 0 && freeSpinInterval > 0 && now / 1000 >= freeSpinNextAt
    ? 1 + Math.floor((now / 1000 - freeSpinNextAt) / freeSpinInterval) : 0;
  const available = Math.min(capacity, Math.max(0, freeSpins) + gained);
  const nextAt = available >= capacity ? 0 : freeSpinNextAt + gained * freeSpinInterval;
  return { available, capacity, nextAt };
}
